import { ConvertGenConfigToCreativeConfig, CreativeServerGenConfig } from "../Creative/CreativeServer";
import { DailyActivity, GetInstantActivity, InstantActivity } from "../Schedule/ScheduleActivity";
import { ContentContextData } from "./ContentContext";
import { ActivityBlockConfigData, ChatConfigData, CloneForQuizClient, CreativeConfigData, DefaultActivityBlockConfigData, DefaultPostConfigData, MessageConfigData, PartyConfigData, PostConfigData, PostElementConfigData, ProjectVoting, QuizConfigData, VotesConfigData } from "./PartyConfigData";

export type ContentPackageConfigData = {
    startTime: number;
    endTime: number;
    main: ActivityBlockConfigData;
    chat?: ChatConfigData;
};


export const DefaultContentPackageConfigData = (): ContentPackageConfigData => {
    return {
        startTime: 0,
        endTime: 0,
        main: DefaultActivityBlockConfigData()
    }
}

export type ContentEnvironment = {
    startTime: number;
    daily: DailyActivity;
    nextDailyActivity : DailyActivity;
    creativeServerConfigs: { [key: string]: CreativeServerGenConfig };
    quizConfigs: { [key: string]: QuizConfigData };
}

export const CreateDevEndlessContentPackage = (time: number) => {
    const post = DefaultPostConfigData();

    const content: ContentPackageConfigData = {
        startTime: time,
        endTime: time + 1000000,
        main: {
            startTime: time,
            endTime: time + 1000000,
            activityType: 'post',
            //chatSource: 'integrated',
            mediaPosition: 'top',
            forceOptionalEnd: false,
            config: post
        }
    }
    return content;
}

export const ExtractContentPackages = (party: PartyConfigData, environment: ContentEnvironment): { content: ContentPackageConfigData, activity: InstantActivity }[] => {
    const ret: { content: ContentPackageConfigData, activity: InstantActivity }[] = [];
    party.main.forEach((act, index) => {
        const instantActivity = GetInstantActivity(environment.daily, environment.nextDailyActivity, act.startTime + environment.startTime);
        const activity = CloneActivityPackage(act, environment, instantActivity.national);
        const chat = activity.chatSourceId === undefined ? undefined : CloneChat(party.chats[activity.chatSourceId], act.startTime, act.endTime, 3.5, environment.startTime, instantActivity.national);

        const content: ContentPackageConfigData = {
            startTime: act.startTime + environment.startTime,
            endTime: act.endTime + environment.startTime,
            main: activity,
            chat: chat
        }
        ret.push({ content: content, activity: instantActivity });
    });
    return ret;
}

export const CloneActivityPackage = (activity: ActivityBlockConfigData, environment: ContentEnvironment, online: number): ActivityBlockConfigData => {
    const absStartTime = environment.startTime;
    var chatId = activity.chatSourceId;
    const config = (() => {
        if (activity.activityType === 'post') {
            const post = ClonePost(activity.config as PostConfigData, absStartTime, online);
            if (post.chatId !== undefined)
                chatId = post.chatId;
            return post;
        }
        else if (activity.activityType === 'chat') {
            const chat = CloneChat(activity.config as ChatConfigData, activity.startTime, activity.endTime, 3.5, absStartTime, online);
            return chat;
        }
        else if (activity.activityType === 'creative') {
            const gen = activity.config as CreativeServerGenConfig;
            const creative = ConvertGenConfigToCreativeConfig(gen);
            environment.creativeServerConfigs[gen.itemId] = gen;
            return creative;
        }
        else if (activity.activityType === 'quiz') {
            const quiz = activity.config as QuizConfigData;
            const cquiz = CloneForQuizClient(quiz);
            environment.quizConfigs[quiz.itemId] = quiz;
            return cquiz;
        }
        else {
            return activity.config;
        }
    })();


    const ret: ActivityBlockConfigData = {
        startTime: absStartTime + activity.startTime,
        endTime: absStartTime + activity.endTime,
        activityType: activity.activityType,
        //chatSource: activity.chatSource,
        chatSourceId: chatId,
        mediaPosition: activity.mediaPosition,
        //chatPosition: activity.chatPosition,
        forceOptionalEnd: activity.forceOptionalEnd,
        config: config,
    }

    return ret;
}

const ClonePost = (post: PostConfigData, absStartTime: number, online: number): PostConfigData => {

    const elements = Array<PostElementConfigData>();
    post.elements.forEach((e) => {
        const element: PostElementConfigData = {
            itemId: e.itemId,
            chatId: e.chatId,
            title: e.title,
            layout: e.layout,
            voting: e.voting === undefined ? undefined : CloneVoting(e.voting, absStartTime, online),
            primary: {
                text: e.primary.text,
                imageSrc: e.primary.imageSrc,
                imageClick: e.primary.imageClick,
                buttonText: e.primary.buttonText,
                buttonClick: e.primary.buttonClick
            },
            secondary: e.secondary === undefined ? undefined : {
                text: e.secondary.text,
                imageSrc: e.secondary.imageSrc,
                imageClick: e.secondary.imageClick,
                buttonText: e.secondary.buttonText,
                buttonClick: e.secondary.buttonClick
            }
        }
        elements.push(element);
    })

    const ret: PostConfigData = {
        itemId: post.itemId,
        title: post.title,
        author: post.author,
        layout: post.layout,
        rotate: post.rotate,
        messageDisplay: post.messageDisplay,
        elementDisplayTime: post.elementDisplayTime,
        messageMixRatio: post.messageMixRatio,
        voting: post.voting === undefined ? undefined : CloneVoting(post.voting, absStartTime, online),
        chatId: post.itemId.replace('mn', 'ch'),
        elements: elements
    }
    return ret;
}

const CloneVoting = (votes: VotesConfigData, absStartTime: number, online: number): VotesConfigData => {


    const ret: VotesConfigData = {
        itemId: votes.itemId,
        impressions: 0,
        likes: 0,
        comments: 0,
        expression: votes.expression,
        created: Math.round(absStartTime + votes.created),
        updated: Math.round(absStartTime + votes.created),
        popularity: (votes.popularity ?? 0.1) * online * 2.0 * 11.2,
        affect: votes.affect,
        react: votes.react
    }
    ProjectVoting(ret, absStartTime + votes.updated);

    if (ret.popularity === undefined) {
        console.log('vote popularity has been blanked');
    }

    return ret;
}

export const CloneChat = (chat: ChatConfigData, startDisplay: number, endDisplay: number, messageRate: number, absStartTime: number, online: number): ChatConfigData => {
    const numMessages = Math.ceil((endDisplay - startDisplay) / 1000 / messageRate) + 10;
   // console.log('Attempting to select ' + numMessages + ' for chat ' + chat.itemId);
    const timeIncrement = 1000 * messageRate;

    const messageSource = chat.messages.slice();
    const messages = Array<MessageConfigData>();
    var time = startDisplay;
    var previousMesageCount = 0;
    for (let i = 0; i < numMessages; i++) {
        const available = Array<number>();
        messageSource.forEach((m, index) => {
            const ms = m.displayStart ?? startDisplay;
            const me = m.displayEnd ?? (startDisplay + (numMessages + 1) * timeIncrement);
            if (time >= ms)
                available.push(index);
        });
        

        if (available.length > 0) {
            const index = Math.floor(Math.random() * available.length);
            const m1 = messageSource[available[index]];
            messageSource.splice(index, 1);

            const m2 = CloneMessage(m1, absStartTime, online);
            previousMesageCount = messages.length;
            messages.push(m2);
            if(messages.length === i){
                time += timeIncrement;
               // console.log('messages.length = ' + messages.length + ' i ' + i + ' num ' + numMessages );
            }
            else
            {
                i--;
                //console.log('Repeating time cycle ' + time + 'available ' + available.length); 
            }
        }
        else {
            time += timeIncrement;
            //console.log('No messages available, time' + time + ' i:' + i)
        }
    }
    //console.log('Selected ' + messages.length + ' for chat ' + chat.itemId);

    const threads = chat.threads.map((thread) => {
        return CloneChat(thread, startDisplay, endDisplay, messageRate, absStartTime, online);
    })

    const ret: ChatConfigData = {
        itemId: chat.itemId,
        chatType: chat.chatType,
        startTime: absStartTime + chat.startTime,
        endTime: absStartTime + chat.endTime,
        threads: threads,
        messages: messages
    }
    return ret;

}

const CloneMessage = (message: MessageConfigData, absStartTime: number, online: number): MessageConfigData => {

    const replies = message.replies.map((reply) => {
        const nr = CloneMessage(reply, absStartTime, online);
        return nr;
    })

    const ret: MessageConfigData = {
        itemId: message.itemId,
        userId: message.userId,
        userColor: message.userColor,
        userIcon: message.userIcon,
        nickname: message.nickname,
        bodyText: message.bodyText,
        image: message.image,
        replies: replies,
        voting: CloneVoting(message.voting, absStartTime, online)
    };
    return ret;
}